// extracted by mini-css-extract-plugin
export var border = "_b-8";
export var brand = "_b-t";
export var button = "_b-l";
export var center = "_b-a";
export var centered = "_b-6";
export var closeButton = "_b-c";
export var disabledWrapper = "_b-m";
export var error = "_b-p";
export var extraLarge = "_b-4";
export var extraSmall = "_b-1";
export var fill = "_b-i";
export var footer = "_b-h";
export var footerAction = "_b-j";
export var footerButtons = "_b-k";
export var header = "_b-7";
export var headerWithClose = "_b-d";
export var icon = "_b-o";
export var info = "_b-s";
export var inline = "_b-9";
export var large = "_b-3";
export var main = "_b-e";
export var modal = "_b-0";
export var nearFull = "_b-5";
export var neutral = "_b-u";
export var noPadding = "_b-g";
export var none = "_b-v";
export var scrollable = "_b-f";
export var small = "_b-2";
export var success = "_b-r";
export var tight = "_b-n";
export var titleIcon = "_b-b";
export var warn = "_b-q";